/**
 * Polyfills for React 18 compatibility with legacy libraries
 * - ReactDOM.render: needed for react-tippy and other legacy tooltip libraries
 */
/* eslint-disable react/no-deprecated */

import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

// Polyfill for ReactDOM.render (removed in React 18)
// This is needed for react-tippy which still uses the old API
if (!ReactDOM.render) {
  const roots = new Map();

  ReactDOM.render = function(element, container, callback) {
    let root = roots.get(container);

    if (!root) {
      root = createRoot(container);
      roots.set(container, root);
    }

    root.render(element);

    if (callback) {
      // React 18 doesn't support callbacks in the same way
      // Execute callback asynchronously
      setTimeout(callback, 0);
    }

    return {
      unmount: () => {
        root.unmount();
        roots.delete(container);
      }
    };
  };

  ReactDOM.unmountComponentAtNode = function(container) {
    const root = roots.get(container);
    if (root) {
      root.unmount();
      roots.delete(container);
      return true;
    }
    return false;
  };
}

export default React;
